import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';

import actions from 'state/mrCollection/shipments/actionCreators';
import initialState from 'state/mrCollection/shipments/initial.state';

const shipments = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setShipmentKeys]: (state, { payload: { shipmentKeys } }) => [
      ...shipmentKeys,
    ],
    [actions.addShipment]: (state, { payload: { shipmentKey } }) => [
      ...state,
      shipmentKey,
    ],
    [actions.removeShipment]: (state, { payload: { shipmentKey } }) =>
      Object.keys(state).length <= 1
        ? state
        : [...reducersUtils.removeKeyFrom.array(state, shipmentKey)],
  },
  initialState
);

export default shipments;
